/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85);


/***/ },

/***/ 85:
/***/ function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	  // otevreni a vycentrovani noveho pop-up okna
	  function openFormInPopUp(url, name, w, h) {
	    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
	
	    var width, height;
	    width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	    height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
	
	    var left = width / 2 - w / 2 + dualScreenLeft;
	    var top = height / 2 - h / 2 + dualScreenTop;
	    var newWindow = window.open(url, name, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	  }
	
	  $('#pojisteni-popup-form').on('click', function (e) {
	    e.preventDefault();
	    openFormInPopUp('http://allianz.studentagency.cz/form.php', 'formPopUpInsurance', 615, 630);
	  });
	});

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** subpage-insurance.js
 **/